import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin } from 'lucide-react';
import { ProjectShowcase } from '../components/ProjectShowcase';
import { sevenIslands, sevenIslandsPhotos } from '../data/sevenIslands';
import { boathouse } from '../data/boathouse';
const ease = [0.23, 1, 0.32, 1] as const;
const featureImage = sevenIslandsPhotos.find(p => p.title === 'The Resort and Island 7');
export function ProjectsPage() {
  return <div className="bg-white" data-id="element-451" data-mp="mv9pqefm46oc">
      {/* Header */}
      <section className="bg-black text-white pt-24 pb-16 px-6 md:px-10" data-id="element-452" data-mp="mw2whfekmw6h">
        <div className="max-w-7xl mx-auto" data-id="element-453" data-mp="8waafxdzp44u">
          <p className="text-[#C5A55A] text-xs tracking-[0.3em] uppercase mb-5" data-id="element-454" data-mp="du22qsijqs9k">
            Projects
          </p>
          <h1 className="text-4xl md:text-6xl font-serif font-bold max-w-3xl leading-tight" data-id="element-455" data-mp="2399ovn6mvsaj">
            What we're developing, and what's already standing.
          </h1>
        </div>
      </section>

      {/* Upcoming */}
      <section className="py-20 px-6 md:px-10" data-id="element-456" data-mp="1ny9tr12cit2">
        <div className="max-w-7xl mx-auto" data-id="element-457" data-mp="1mn5nq3ph91f">
          <h2 className="text-xs tracking-[0.3em] uppercase text-gray-500 mb-8" data-id="element-458" data-mp="3sw2lfdjt4nxo">
            Upcoming
          </h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.3,
          ease
        }} data-id="element-459" data-mp="ag0a9pb4tz3c">
            <Link to={sevenIslands.slug} className="group grid grid-cols-1 lg:grid-cols-12 bg-[#0A0A0A] text-white overflow-hidden" data-id="element-460" data-mp="3exm9n873878o">
              <div className="lg:col-span-8 overflow-hidden" data-id="element-461" data-mp="3nxrd5795ulhk">
                <img src={featureImage?.src ?? sevenIslands.heroImage} alt="Aerial rendering of the 7 Islands resort lagoon and community island" className="w-full h-72 md:h-[460px] object-cover transition-transform duration-300 ease-out group-hover:scale-[1.02]" data-id="element-462" data-mp="3iwli32s12m4v" />
              </div>
              <div className="lg:col-span-4 flex flex-col p-8 md:p-10" data-id="element-463" data-mp="3s0yi1pukn5xf">
                <span className="text-[#C5A55A] text-xs tracking-[0.25em] uppercase" data-id="element-464" data-mp="r8avgdv86gt">
                  Coming {sevenIslands.opening}
                </span>
                <h3 className="font-serif font-bold mt-4" data-id="element-465" data-mp="9szbi6tjtn3t">
                  <span className="block text-4xl md:text-5xl" data-id="element-466" data-mp="9sg25ehys71e">
                    {sevenIslands.name}
                  </span>
                  <span className="block text-xl italic font-normal text-[#C5A55A] mt-2" data-id="element-467" data-mp="3d9y2z1zbkdsb">
                    {sevenIslands.subtitle}
                  </span>
                </h3>
                <p className="flex items-center gap-2 text-gray-400 text-sm mt-5" data-id="element-468" data-mp="3i6y9fe02zijy">
                  <MapPin className="w-4 h-4 text-[#C5A55A] shrink-0" aria-hidden="true" data-id="element-469" data-mp="3n12e1qlvjehv" />
                  {sevenIslands.location}
                </p>
                <p className="text-gray-300 leading-relaxed mt-6" data-id="element-470" data-mp="2uiyes2znf803">
                  {sevenIslands.tagline}
                </p>
                <span className="mt-auto pt-10 inline-flex items-center gap-2 font-medium text-white group-hover:text-[#C5A55A] transition-colors duration-200" data-id="element-471" data-mp="2mymjkg8ofx1z">
                  Explore the project
                  <ArrowRight className="w-5 h-5 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-472" data-mp="2d0gejprkqasw" />
                </span>
              </div>
            </Link>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.3,
          ease
        }} className="mt-6" data-id="element-473" data-mp="1z9uys9xf2gz8">
            <Link to={boathouse.slug} className="group grid grid-cols-1 md:grid-cols-12 border border-gray-200 overflow-hidden hover:border-[#C5A55A] transition-colors duration-200" data-id="element-474" data-mp="1pa4344x4dvxk">
              <div className="md:col-span-5 overflow-hidden" data-id="element-475" data-mp="3ge0bc0dtu8w7">
                <img src={boathouse.heroImage} alt="Concept rendering of the Boathouse tiki bar and grill" className="w-full h-60 md:h-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.02]" data-id="element-476" data-mp="3gejpr749qf5h" />
              </div>
              <div className="md:col-span-7 flex flex-col p-8 md:p-10" data-id="element-477" data-mp="3bkoz1jq8wzww">
                <span className="text-[#C5A55A] text-xs tracking-[0.25em] uppercase" data-id="element-478" data-mp="2wo7rl3l6g5fm">
                  {boathouse.status}
                </span>
                <h3 className="font-serif font-bold text-black mt-4" data-id="element-479" data-mp="2npchvhixcd7k">
                  <span className="text-3xl md:text-4xl" data-id="element-480" data-mp="2nr5tlb8e9nmf">{boathouse.name}</span>
                  <span className="text-xl italic font-normal text-gray-500 ml-3" data-id="element-481" data-mp="2sopeuv3if0nv">
                    {boathouse.subtitle}
                  </span>
                </h3>
                <p className="text-gray-600 leading-relaxed mt-4 max-w-xl" data-id="element-482" data-mp="qx2n2rbsn1qc">
                  {boathouse.tagline}
                </p>
                <span className="mt-auto pt-8 inline-flex items-center gap-2 font-medium text-black group-hover:text-[#C5A55A] transition-colors duration-200" data-id="element-483" data-mp="110zi9w88ngcf">
                  Explore the project
                  <ArrowRight className="w-5 h-5 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-484" data-mp="19ucjdlggho9l" />
                </span>
              </div>
            </Link>
          </motion.div>
        </div>
      </section>

      <ProjectShowcase data-id="element-485" data-mp="1erw85fas5jfs" />
    </div>;
}